import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
    vendorAppointments: [],
    error: null,
    loader: false,
    featured: {},
    total: 0,
    is_more: false,
    last_page: 1,
    current_page: 1,
    per_page: PAGELENGTH,
    popup: {
        show: false,
        item: {}
    },
}

export const vendorAppointmentsSlice = createSlice({
    name: 'vendorAppointments',
    initialState: initialState,
    reducers: {
        setAppointment: (state, { payload }) => {
            state.vendorAppointments = payload?.data ?? payload;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setVendorAppointments: (state, { payload }) => {
            state.vendorAppointments = payload?.data;
            state.total = payload?.total;
            state.is_more = payload?.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        setMoreVendorAppointments: (state, { payload }) => {
            state.data = state.data.concat(payload.data);
            state.total = payload.total;
            state.is_more = payload.is_more;
            state.last_page = payload?.last_page;
            state.current_page = payload?.current_page;
            state.per_page = payload?.per_page;
        },
        removeAppointment: (state, { payload }) => {
            state.error = payload
        },
        clearAllAppointment: (state, { payload }) => {
            state.loader = payload
        },
        setError: (state, { payload }) => {
            state.error = payload
        },
        setLoader: (state, { payload }) => {
            state.loader = payload
        },
        setAddAppointmentPopup: (state, { payload }) => {
            state.popup = payload
        },
        closeAppointmentPopup: (state) => {
            state.popup.show = false;
            state.popup.item = {}
        }
    }
})

export const fetchVendorAppointments = (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true))
    try {
  
      const result = await Api.fetchVendorAppointments(page, params)
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setVendorAppointments(result.data.data));
        } else {
          dispatch(setVendorAppointments(result.data.data));
        }
      }
      else if (result?.status == 422) {
        dispatch(setError(result.data))
      }
    } catch (error) {
      console.log("error", error)
  
    }
    !disableLoader && dispatch(setLoader(false))
  }

export const fetchVendorAppointmentView = (id, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const result = await Api.fetchVendorAppointmentView(id)
        if (result.status >= 200 && result.status < 300) {
            callback && callback(true, result?.data?.message, result?.data?.data)
        } else {
            callback && callback(false, result?.data?.message, null, result?.status)
        }
    } catch (error) {
        callback && callback(false, error?.data?.message)
    }
    dispatch(setLoader(false))
}

export const fetchVendorAppointmentLogs = (id, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}))
    dispatch(setLoader(true))
    try {
        const result = await Api.fetchVendorAppointmentLogs(id)
        if (result.status >= 200 && result.status < 300) {
            callback(true, result?.data?.message, result?.data?.data)
        } else if (result?.status == 422) {
            callback(false, result?.data?.message)
        }
    } catch (error) {
        // callback(false)
        callback(false, error?.data?.message)
    }
    dispatch(setLoader(false))
}

export const vendorAppointmentAssign = (id, data, callback) => async (dispatch) => {
    dispatch(setLoader(true))
    try {
        const result = await Api.vendorAppointmentAssign(id, data)
        if (result.status >= 200 && result.status < 300) {
            callback && callback(true, result?.data?.message)
        } else {
            callback && callback(false, result?.data?.message || 'An error occurred.')
        }
    } catch (error) {
        callback && callback(false, error?.data?.message || 'An error occurred.')
    }
    dispatch(setLoader(false))
}

export const vendorAppointmentDecline = (id, data, callback) => async (dispatch) => {
    dispatch(setLoader(true))
    try {
        const result = await Api.vendorAppointmentDecline(id, data)
        if (result.status >= 200 && result.status < 300) {
            callback && callback(true, result?.data?.message)
        } else {
            callback && callback(false, result?.data?.message || 'An error occurred.')
        }
    } catch (error) {
        callback && callback(false, error?.data?.message || 'An error occurred.')
    }
    dispatch(setLoader(false))
}

export const {
    setAppointment, setVendorAppointments,
    clearAllAppointment, setLoader,
    setError, setMoreVendorAppointments,
    setAddAppointmentPopup, closeAppointmentPopup

} = vendorAppointmentsSlice.actions


export default vendorAppointmentsSlice.reducer
export const vendorAppointmentsSelector = state => state.vendorAppointments


